var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const isWeChatMiniProgram = false;
const isWeb = true;
const isMRN = false;
import { useDispatch, useSelector } from '@max/max-redux';
import { Actions } from '../../store';
import { getStorage } from '@max/meituan-uni-storage';
import { useCallback, useEffect, useState } from '@max/max';
import Toast from '@max/leez-toast';
let getCityInfo;
if (true)
    getCityInfo = require('./index.web').default;
export function useLocationInfo(p) {
    const refreshCurrentCity = useSelector(state => state.citySelection.refreshCurrentCityCount);
    const dispatch = useDispatch();
    const [locationDataLoaded, setLocationDataLoaded] = useState(false); // 新状态
    const [tempCityInfo, setTempCityInfo] = useState(null);
    // 获取城市名称的辅助函数
    const getCityNameById = useCallback((cityId) => {
        const city = p.cityInfos.find(item => String(item.id) === String(cityId));
        return city ? city.name : '';
    }, [p.cityInfos]);
    const initLocationData = () => __awaiter(this, void 0, void 0, function* () {
        const cityInfo = yield getCityInfo(p);
        // 如果是web环境且label为空，尝试通过城市ID获取城市名称
        if (cityInfo.value && !cityInfo.label) {
            const cityName = getCityNameById(cityInfo.value);
            if (cityName) {
                cityInfo.label = cityName;
            }
        }
        setTempCityInfo(cityInfo); // 保存获取到的城市信息
        // 获取初始的城市
        dispatch({
            type: Actions.updateLocationCity,
            data: cityInfo
        });
        // 初始化
        if (refreshCurrentCity > 0) {
            Toast.open({
                content: '定位刷新成功'
            });
        }
        updateRecentCity(cityInfo);
        setLocationDataLoaded(true);
    });
    const removeDuplicatedCity = (cities) => {
        const set = new Set();
        const newCities = [];
        cities.forEach((city) => {
            if (city.id && city.name && !set.has(city.id)) {
                newCities.push(city);
                set.add(city.id);
            }
        });
        return newCities;
    };
    const updateRecentCity = (cityItem) => __awaiter(this, void 0, void 0, function* () {
        // 同步最近访问城市
        try {
            const cityResult = (yield getStorage({
                key: 'hotelPoilistCitySelection__recentcities'
            }));
            const cities = (cityItem === null || cityItem === void 0 ? void 0 : cityItem.value) ? [{
                    name: cityItem.label,
                    id: cityItem.value
                }, ...((cityResult === null || cityResult === void 0 ? void 0 : cityResult.data) || [])] : (cityResult === null || cityResult === void 0 ? void 0 : cityResult.data) || [];
            const newCities = removeDuplicatedCity(cities);
            dispatch({
                type: Actions.updateRecentCity,
                data: newCities
            });
        }
        catch (err) {
            console.log('获取城市缓存信息失败', err);
        }
    });
    useEffect(() => {
        initLocationData();
    }, [refreshCurrentCity]);
}
